import { alarmStore } from "./alarm-store"
import { toast } from "sonner"
import { sendAlarmApi } from "@/apis/alarm-api"
import Wrapper from "@/components/wrapper"

const formatValue = (value, fallback = "-") => {
  if (value === null || value === undefined || value === "") return fallback
  return String(value)
}

const buildAddress = (data) => {
  const danji = formatValue(data?.danji, "")
  const dong = formatValue(data?.dong, "")
  const ho = formatValue(data?.ho, "")

  const parts = [danji ? `${danji}단지` : "", dong ? `${dong}동` : "", ho ? `${ho}호` : ""].filter(
    Boolean
  )

  return parts.join(" ") || "-"
}

const buildLeakAlarmMessage = (data) => {
  const usrNm = `${formatValue(data?.ho, "-")}호`
  const newAdr = buildAddress(data)
  const leakStart = formatValue(data?.leak_start_at ?? data?.leakStartAt)
  const leakEnd = formatValue(data?.leak_end_at ?? data?.leakEndAt)
  const leakAmount = formatValue(data?.leak_volume ?? data?.leakAmount)
  const leakSymptom = formatValue(data?.leak_type ?? data?.leakType)
  const waterBill = formatValue(data?.water_bill, "15")
  const leakAmountH = formatValue(data?.leak_amount_h ?? data?.leakAmountH, leakAmount)

  return (
    usrNm +
    " 고객님\n" +
    newAdr +
    " 에서\n" +
    leakStart +
    " 시 부터 " +
    leakEnd +
    " 시 까지\n" +
    leakAmount +
    " 만큼의 옥내누수가 의심되오니 점검 받아보시기 바랍니다.\n\n" +
    "- 증상 : " +
    leakSymptom +
    "\n" +
    "- 옥내누수량 : 1시간당 " +
    leakAmountH +
    "L 이상\n" +
    "- 이번 달 예상 수도요금 : " +
    waterBill +
    "만원\n\n\n" +
    "* 본 메시지는 옥내누수 알림서비스를 신청하신 고객님 중 옥내누수가 의심되는 고객님께 발송되는 메시지입니다.\n" +
    "* 문의사항이 있으신 경우, 해당 지역 상수도사업본부를 통하여 주시기 바랍니다."
  )
}

const AlarmModal = () => {
  const { open, row, closeModal } = alarmStore()

  if (!open || !row) return null

  const contents = buildLeakAlarmMessage(row)
  // TODO: [문자알림] 개인 번호를 받아서 전송할 수 있는 구조로 변경 예정
  const sendAlarm = async () => {
    const { success } = await sendAlarmApi({ phone: "01051572868", contents })

    if (success) {
      toast.success("알림 전송 완료")
    } else {
      toast.error("전송 실패")
    }

    closeModal()
  }

  return (
    <Wrapper.modal onClose={closeModal} className="p-6 w-125 rounded-xl">
      <h2 className="text-lg font-bold mb-3">누수 알림 전송</h2>

      <div className="bg-[#F7F7F8] p-3 rounded-2xl">
        <div className="bg-white p-2 rounded-xl shadow-sm max-w-sm text-sm leading-relaxed whitespace-pre-wrap">
          {contents}
        </div>
      </div>

      <div className="flex justify-end gap-2 mt-4">
        <button
          onClick={closeModal}
          className="px-4 py-1.5 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
        >
          취소
        </button>

        <button
          onClick={sendAlarm}
          className="px-4 py-1.5 bg-gray-900 text-white rounded-lg hover:bg-gray-800 transition-colors cursor-pointer"
        >
          전송
        </button>
      </div>
    </Wrapper.modal>
  )
}

export default AlarmModal
